import { connect } from 'react-redux'

import { findCinemaId, findEventId } from '../../global/helpers'

const mapStateToProps = (state) => {
    const eventid = findEventId(state)
    const cinemaid = findCinemaId(state)

    return {
        eventid,
        cinemaid,
    }
}

const mapDispatchToProps = {}

const hocExpiredLimit = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocExpiredLimit
